import generateTypes from '../utils/generateTypes';

export const GET_EVENTS = generateTypes('GET_EVENTS');
export const UPDATE_EVENTS = 'UPDATE_EVENTS';
export const UPDATE_SIDEBAR_EVENTS = 'UPDATE_SIDEBAR_EVENTS';
export const UPDATE_CURRENT_EVENT = 'UPDATE_CURRENT_EVENT';
export const UPDATE_ACTIVE_EVENTS = 'UPDATE_ACTIVE_EVENTS';
export const RESET_EVENTS = 'RESET_EVENTS';
